import { render, staticRenderFns } from "./targetSplit.vue?vue&type=template&id=37dfd68a&scoped=true"
import script from "./targetSplit.vue?vue&type=script&lang=js"
export * from "./targetSplit.vue?vue&type=script&lang=js"
import style0 from "./targetSplit.vue?vue&type=style&index=0&id=37dfd68a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dfd68a",
  null
  
)

export default component.exports